/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../contexts';

interface IRolesAndPermissionGuard{
  permissionName:string;
  children:any;
  hasErrorTemplate?:any;
}
const RolesAndPermissionGuard = ({ permissionName, children, hasErrorTemplate }:IRolesAndPermissionGuard) => {
  const evnChecker = process.env.REACT_APP_TYPE === 'ADMIN';
  const { userPermissions }:any = useGlobalState();
  // const [userPermission, setUserPermission] = useState([]);
  const checkIfPermissionExist = userPermissions?.includes(permissionName);
  // useEffect(() => {
  //   const userPermissionName = profile?.role?.permissions?.map((list) => list?.name);
  //   setUserPermission(userPermissionName);
  // }, [profile]);

  // || !userPermissions

  if (evnChecker && (!permissionName || !checkIfPermissionExist)) {
    return hasErrorTemplate || null;
  }
  return children;
};

export const useRolesAndPermissionGuard = (permissionName: string) => {
  const evnChecker = process.env.REACT_APP_TYPE === 'ADMIN';
  const { userPermissions }:any = useGlobalState();
  const checkIfPermissionExist = userPermissions?.includes(permissionName);
  if (evnChecker && (!permissionName || !checkIfPermissionExist)) {
    return false;
  }
  return true;
};
export default RolesAndPermissionGuard;
